import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Warranty: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-3.93 0-7.85-.72-11.59-2.15-38.33-14.26-228.41-97.76-228.41-349.14v-168.7h30v168.7c0 231.7 174.04 308.09 208.93 321.05l.2.08c.59.23 1.15.23 1.74 0l.18-.07c34.89-13.02 208.95-89.68 208.95-321.12v-168.65h30v168.65c0 251.11-190.08 334.89-228.4 349.2-3.74 1.44-7.67 2.15-11.6 2.15z' />
    <path d='m150 120h480v30h-480z' />
    <path d='m385.23 464.71c.93-1.11 139.77-224.62 139.77-224.62-14.05-8.78-32.56-4.51-41.34 9.54l-112.36 179.77-63.66-73.24c-12.5 10.87-13.83 29.82-2.96 42.32l31.86 36.65-.22-.05 26.14 29.88c2.97 3.39 7.12 5.12 11.29 5.12 3.51 0 7.03-1.22 9.87-3.71.48-.42 1.61-1.66 1.61-1.66z' />
  </IconBase>
));

Warranty.displayName = 'Warranty';

export default Warranty;
